<template>
    <div>
        <myHeader
            :year="year"
            :month="month"
            @yearNum="yearNum"
            @monthNum="monthNum"
        />
        <div class="week">
            <span v-for="i in weekTxt" :key="i" >{{ i }}</span>
        </div>
        <div class="box">
        <div class="weeks">
            <p :class="{choice: choiceColor(i)}" v-for="(i,index) in weeks" :key="index" @click="choiceWeek(i)">第{{getWeek(i)}}周</p>
        </div>
        <div class="content" v-if="dayList.length>0">
            <span
                :class="{
                    isNotMonth: isNotMonth(d),
                    day: !isNotMonth(d),
                    today: isToday(d),
                }"
                v-for="(d, index) in dayList"
                :key="index"
                >{{ d.getDate() }}</span
            >
        </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import myHeader from "./header.vue";
import * as utils from "../utils";
export default {
    name: "week",
    props:{
    },
    components: {
        myHeader,
    },
    data() {
        return {
            year: dayjs().get("year"),
            month: dayjs().get("month") + 1,
            weekTxt: ["一", "二", "三", "四", "五", "六",'日'],
            choiceWeekAct: this.value,
            dayList: [],
            weeks:[]
        };
    },
    mounted() {
        this.getShowDays(this.year,this.month);
    },
    methods: {
        // index页面 传入月份后进行二次调用计算
        two(){
            this.getShowDays(this.year,this.month);
        },
        //计算显示得天数,我们需要计算出指定得年和月得第一天,在当前星期里是周几,在朝前面移动出现得天数
        //在6航7列显示42个日期
        getShowDays(year,month) {
            this.dayList = [];
            this.weeks = []
            // 构造一个传入得年月日期对象
            let firstDay = new Date(year, month-1, 1);
            // 通过getDay() 获取这一天在星期数里出现得位置(0-6)
            let weeks = firstDay.getDay();
            // 计算面板中得第一天
            if (weeks == 0) {
                weeks = 7;
            }
            let firstDate = firstDay - (weeks-1) * 24 * 60 * 60 * 1000;
            // console.log(firstDay);
            // 计算42个日期数

            for (let i = 0; i < 42; i++) {
                if (i%7 == 0) {
                    // console.log(new Date(firstDate + i * 24 * 60 * 60 * 1000));
                    this.weeks.push(new Date(firstDate + i * 24 * 60 * 60 * 1000))
                }
                this.dayList.push(
                    new Date(firstDate + i * 24 * 60 * 60 * 1000)
                );
            }
            // console.log(this.choiceDay);
            // console.log(this.dayList);
            // console.log(this.weeks);

            // return arr;
        },
        isNotMonth(d) {
            if (d.getMonth() + 1 != this.month && d.getYear() != this.year) {
                return true;
            }
            return false;
        },
        yearNum(v) {
            // console.log(v);
            this.year = v;
           this.getShowDays(this.year,this.month);
        },
        monthNum(v) {
            // console.log(v);
            this.month = v;
            this.getShowDays(this.year,this.month);
        },
        isToday(v) {
            let { year, month, day } = utils.formatTime(new Date());
            let { year: y, month: m, day: d } = utils.formatTime(v);
            return year == y && month == m && day == d;
        },
        choiceWeek(d) {
            console.log(d,'dddd');
            this.choiceWeekAct = d
            console.log(new Date(d.getTime() + 6 * 24 * 60 * 60 * 1000));
            let obj = {}
            obj.startDate = d;
            obj.endDate = new Date(d.getTime() + 6 * 24 * 60 * 60 * 1000)
            obj.index=1
            this.$emit('week',obj)
        },
        choiceColor(v) {
            let { year, month, day } = utils.formatTime(this.choiceWeekAct);
            let { year: y, month: m, day: d } = utils.formatTime(v);
            return year == y && month == m && day == d;
        },
        //计算传入得日期是一年得第几周
 getWeek(dt) {
    let d1 = new Date(dt);
    let d2 = new Date(dt);
    d2.setMonth(0);
    d2.setDate(1);
    let rq = d1 - d2;
    let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
    let num = Math.ceil(days / 7);
    return num;
}
    },
};
</script>

<style lang="scss" scoped>
.week {
    width: 80%;
    margin-top: 6px;
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 2px;
    margin-left: 19%;
    span {
        flex: 1;
        text-align: center;
    }
}
.box{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .weeks{
        width: 19%;
    p{
        height: 39px;
        line-height: 39px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        &:hover {
                color: #409eff;
                // font-weight: 700;
            }
    }
    .choice {
            background-color: #409eff;
            border-radius: 5px;
            color: #fff;
            &:hover{
                color:#fff ;
            }
        }
    }
    .content {
        width: 80%;
        height: 235px;
        border-left: 1px solid #e4e7ed;
        display: flex;
        flex-wrap: wrap;
        .day {
            width: 36px;
            height: 39px;
            text-align: center;
            line-height: 38px;
            
        }
        .isNotMonth {
            color: #c0c4cc;
            width: 36px;
            height: 39px;
            text-align: center;
            line-height: 38px;
        }
        .today {
            color: #409eff;
            font-weight: 700;
        }
        
    }
}
</style>